export interface Product {
  id: string;
  productId: string;
  name: string;
  description: string;
  price: number | null;
  priceFormatted: string;
  size: string;
  category: string;
  metadataCategory?: string; // AI-classified category from metadata
  images: string[];
  stockQuantity?: number;
  sku?: string;
  page: number;
  inStock: boolean;
  imagePath?: string; // For backward compatibility with JSON
  material?: string;
  keywords?: string[];

  // Galway Crystal specific fields
  vendor?: string;
  type?: string; // Subcategory for Galway Crystal
  customizable?: boolean;
  customizationFields?: string;
  url?: string; // External product URL
  localImage?: string; // Galway Crystal image path
  productIdExternal?: string; // External product ID
}

// Helper function to get display category (metadata category if available, otherwise original)
export function getDisplayCategory(product: Product): string {
  return product.metadataCategory || product.category;
}

export interface ProductVariant {
  name: string; // Base display name (e.g., "A0256")
  description: string;
  category: string;
  variants: Product[]; // Array of all variants (G, S, B, etc.)
  defaultVariant: Product; // First variant (usually Gold)
  minPrice: number;
  maxPrice: number;
  priceDisplay: string; // "€X.XX" or "€X.XX - €Y.YY" if range
  hasMultipleVariants: boolean;
  baseId: string; // Base product ID without variant suffix
}
